module.exports = __webpack_public_path__ + "media/images/logo-white-59512851bec3b0deb5266f8d7c0f2c49.png";